import { Routes, Route } from "react-router-dom"
import PicassoRoutes from "@/router/picasoRoutes"

const AppRouter = () => {

  return (
    <Routes>
      <Route path="/*" element={<PicassoRoutes />} />
      {/* </Route>    */}
    </Routes>
  )
}

export default AppRouter
